/**
 * all assets are stored in frontend-client/public/*
 */
const NightInTitle = '/night-in/night-in-image-placeholder-desktop.png';
const NightinImagePlaceholder = '/night-in/night-in-image-placeholder.jpg';
const NightinIconTriviaOne = '/night-in/icons/trivia-icon-1.png';
const NightinIconTriviaTwo = '/night-in/icons/trivia-icon-2.png';
const NightinIconTriviaThird = '/night-in/icons/trivia-icon-3.png';
const SafetyCenterHeroBlockDesktop = '/safety/safety-center-hero-block-desktop.png';
const SafetyCenterHeroBlockMobile = '/safety/safety-center-hero-block-mobile.png';

enum PlaceholderType {
    NIGHT_IN_TITLE = 'NIGHT_IN_TITLE',
    NIGHT_IN_IMAGE_PLACEHOLDER = 'NIGHT_IN_IMAGE_PLACEHOLDER',
    NIGHT_IN_ICON_TRIVIA_ONE = 'NIGHT_IN_ICON_TRIVIA_ONE',
    NIGHT_IN_ICON_TRIVIA_TWO = 'NIGHT_IN_ICON_TRIVIA_TWO',
    NIGHT_IN_ICON_TRIVIA_THREE = 'NIGHT_IN_ICON_TRIVIA_THREE',
    SAFETY_CENTER_HERO_BLOCK_DESKTOP = 'SAFETY_CENTER_HERO_BLOCK_DESKTOP',
    SAFETY_CENTER_HERO_BLOCK_MOBILE = 'SAFETY_CENTER_HERO_BLOCK_MOBILE',
}

const mapPlaceholderTypeToImage: { [key in PlaceholderType]: string } = {
    [PlaceholderType.NIGHT_IN_TITLE]: NightInTitle,
    [PlaceholderType.NIGHT_IN_IMAGE_PLACEHOLDER]: NightinImagePlaceholder,
    [PlaceholderType.NIGHT_IN_ICON_TRIVIA_ONE]: NightinIconTriviaOne,
    [PlaceholderType.NIGHT_IN_ICON_TRIVIA_TWO]: NightinIconTriviaTwo,
    [PlaceholderType.NIGHT_IN_ICON_TRIVIA_THREE]: NightinIconTriviaThird,
    [PlaceholderType.SAFETY_CENTER_HERO_BLOCK_DESKTOP]: SafetyCenterHeroBlockDesktop,
    [PlaceholderType.SAFETY_CENTER_HERO_BLOCK_MOBILE]: SafetyCenterHeroBlockMobile,
};

export const Assets = {
    NIGHT_IN_TITLE: mapPlaceholderTypeToImage[PlaceholderType.NIGHT_IN_TITLE],
    NIGHT_IN_IMAGE_PLACEHOLDER:
        mapPlaceholderTypeToImage[PlaceholderType.NIGHT_IN_IMAGE_PLACEHOLDER],
    NIGHT_IN_ICON_TRIVIA_ONE: mapPlaceholderTypeToImage[PlaceholderType.NIGHT_IN_ICON_TRIVIA_ONE],
    NIGHT_IN_ICON_TRIVIA_TWO: mapPlaceholderTypeToImage[PlaceholderType.NIGHT_IN_ICON_TRIVIA_TWO],
    NIGHT_IN_ICON_TRIVIA_THREE:
        mapPlaceholderTypeToImage[PlaceholderType.NIGHT_IN_ICON_TRIVIA_THREE],
    SAFETY_CENTER_HERO_BLOCK_DESKTOP:
        mapPlaceholderTypeToImage[PlaceholderType.SAFETY_CENTER_HERO_BLOCK_DESKTOP],
    SAFETY_CENTER_HERO_BLOCK_MOBILE:
        mapPlaceholderTypeToImage[PlaceholderType.SAFETY_CENTER_HERO_BLOCK_MOBILE],
};
